<template>
    <div class="wrap">
        <h1>비밀번호 찾기</h1>
        <div class="find-pw">
            <h2>이메일로 인증번호 보내기</h2>
            <ul>
                <li><input type="email" id="user-email" placeholder="이메일 주소" v-model="form.email"></li>
                <li><input type="text" id="user-name" placeholder="이름" v-model="form.dr_name"></li>
                <li class="clearfix">
                    <input type="tel" id="user-phone" placeholder="휴대전화번호"
                           :value="form.contact" @input="phone_hypen($event.target.value)" :disabled="is_sent_verify_no">
                    <template v-if="!is_sent_verify_no">
                        <button type="send-num" @click="request_verify_no">인증번호 발송</button>
                    </template>
                    <template v-else>
                        <button type="send-num" disabled>(인증유효:30분)</button>
                    </template>
                </li>
                <li><input type="text" id="user-num" v-model="verify_no" placeholder="인증번호 6자리 숫자 입력"></li>
            </ul>
            <ul class="btn-list">
                <li><button class="btn-cancel" @click="$router.push('/login')">취소</button></li>
                <li><button class="btn-ok" @click="check_verify_no">확인</button></li>
            </ul>
        </div>
    </div>
</template>

<script>
  import { STATUS_CODE } from '@/lib/constants'

  export default {
    name: 'step1',
    data() {
      return {
        form: {
          email: '',
          contact: '',
          dr_name: ''
        },
        dr_id: '',
        verify_no: '',
        is_sent_verify_no: false
      }
    },
    methods: {
      async request_verify_no () {
        let {data} = await this.axios.post('/auth/dr/send_ver', this.form)
        let {resp} = data

        this.dr_id = resp.dr_id

        // console.log("resp", resp.dr_id)
        // console.log("resp", resp.verify_no)

        // uid를 전달 받아야 한다.

        if (data.status !== STATUS_CODE.OK) return alert(data.msg)
        //alert('인증번호 전송이 되었습니다(유효시간: 30분) : '+ resp.verify_no)
        alert('인증번호 전송이 되었습니다(유효시간: 30분)')
        this.is_sent_verify_no = true
      },
      test_on_submit () {
        this.$emit('onSubmit', 'verify_no', 'dr_id')
      },
      async check_verify_no () {

        let post_data = { phone_no: this.form.contact, verify_no: this.verify_no }

        let {data} = await this.axios.post('/auth/dr/check_ver', post_data)
        let {resp} = data

        if (data.status !== STATUS_CODE.OK) return alert(data.msg)

        this.$emit('onSubmit', this.verify_no, this.dr_id, this.form.contact)
      },
      phone_hypen (str) {
        this.form.contact = this.autoHypenPhone(str)
      },
      autoHypenPhone (str) {
        str = str.replace(/[^0-9]/g, '')
        if (str.length < 4) {
          return str
        } else if (str.length < 7) {
          return str.substr(0, 3) + '-' + str.substr(3)
        } else if (str.length < 11) {
          return str.substr(0, 3) + '-' + str.substr(3, 3) + '-' + str.substr(6)
        } else {
          return str.substr(0, 3) + '-' + str.substr(3, 4) + '-' + str.substr(7)
        }
        return str
      }
    }
  }
</script>

<style scoped>
    .wrap {
        width: 100%;
        height: 100vh;
        padding: 50px 0;
        background-color: #f5f6fa;
    }

    .wrap h1 {
        color: #474747;
        text-align: center;
        letter-spacing: -.5px;
        font: 400 32px 'Noto Sans KR', sans-serif;
    }

    .find-pw {
        width: 100%;
        max-width: 500px;
        padding: 50px 55px;
        position: relative;
        background-color: #fff;
        border: 1px solid #eee;
        box-sizing: border-box;
        margin: 70px auto 35px;
    }

    .find-pw h2 {
        margin-bottom: 50px;
        font: 400 18px 'Noto Sans KR', sans-serif;
    }

    .find-pw li {margin-bottom: 10px;}

    .find-pw input {
        color: #b0b0b0;
        width: 100%;
        height: 50px;
        padding: 0 20px;
        border: 1px solid #d2d2d2;
        box-sizing: border-box;
        font: 400 16px 'Noto Sans KR', sans-serif;
    }

    #user-phone,
    #user-phone + button {float: left;}

    #user-phone {
        width: 250px;
        margin-right: 13px;
    }

    #user-phone + button {
        width: 124px;
        height: 50px;
        border: none;
        padding: 0;
        color: #fff;
        box-sizing: border-box;
        background-color: #9c9c9c;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }

    #user-num {background-color: #f6f6f6;}

    .btn-list {
        font-size: 0;
        text-align: center;
        margin-top: 50px;
    }

    .btn-list li {
        width: 120px;
        height: 50px;
        display: inline-block;
        box-sizing: border-box;
    }

    .btn-list li:first-child {border: 1px solid #d2d2d2; margin-right: 30px;}
    .btn-list li:last-child {background-color: #746ce6;}

    .btn-list li button {
        padding: 0;
        border: none;
        background-color: transparent;
        font: 400 16px/50px 'Noto Sans KR', sans-serif;
    }

    .btn-list button{
      width: 100%;
      cursor: pointer;
    }
    .btn-list .btn-cancel {color: #b0b0b0;}
    .btn-list .btn-ok {color: #fff;}
</style>